import api from 'common/api';

export const getCustomsClearanceRequestAPI = (params: any) => api.get('/customs-clearance-request-export/list', params);

export const getCustomsClearanceRequestDetailAPI = (params: any) =>
  api.get('/customs-clearance-request-export/detail', params);

export const getPicAPI = (params: any) => api.get('/customs-clearance-request-export/pic', params);

export const addCustomsClearanceRequestAPI = (params: any) => api.post('/customs-clearance-request-export', params);

export const updateCustomsClearanceRequestAPI = (params: any) => api.put('/customs-clearance-request-export', params);

export const deleteCustomsClearanceRequestAPI = (params: any) =>
  api.put('/customs-clearance-request-export/delete', params);

export const updateDlCustomsClearanceRequestAPI = (params: any) =>
  api.post('/customs-clearance-request-export/update-dl', params);

export const getHolidayAPI = (params: any) => api.get('/customs-clearance-request-export/holiday-list', params);

export const uploadOutsideDocAPI = (params: any) =>
  api.post('/customs-clearance-request-export/document-upload', params);

export const getCustomsClearanceRequestCalendarAPI = (params: any) =>
  api.get('/customs-clearance-request-export/calender-list', params);

export const foldFlagHblDisplayCalendarFlgAPI = (params: any) =>
  api.post('/customs-clearance-request-export/update-calendar-display-flg', params);

export const DOWNLOAD_CUST_CLEAR_REQ_FILE_API = '/customs-clearance-request-export/download';
